import * as React from "react";
import { withStyles } from "@mui/styles";

import { Box, Typography } from "@mui/material";
import "./Tablisting.css";

const styles = {
  box: {
    backgroundColor: "white",
    borderBottomLeftRadius: "1em",
    borderBottomRightRadius: "1em",
    overflow: "auto",
    overflowX: "hidden",
    paddingBottom: 5,
    boxShadow: "0px 1px 2px #00000029",
  },
  settlementBox: {
    backgroundColor: "white",
    borderRadius: "0em",
    overflow: "auto",
    overflowX: "hidden",
    paddingBottom: 5,
    boxShadow: "0px 1px 2px #00000029",
  },
  inner: {
    padding: 20,
    overflow: "auto",
    overflowX: "hidden",
    paddingBottom: 10,
  },
};
interface tablistTileType {
  title?: string;
}
const TablistingBox: React.FC<React.PropsWithChildren<tablistTileType>> = ({
  children,
  title,
}) => {
  return (
    <Box className="innerScroll1">
      <Typography>{title}</Typography>
      <Box>{children}</Box>
    </Box>
  );
};

export default TablistingBox;
